export default "__VITE_ASSET__hQ6KnMsl__"